export enum AntiFraudType {
  NONE = 0,
  PRO = 1,
  FREE = 2,
}
